module.exports = __webpack_public_path__ + "static/img/55.d05c9d81.png";